import { render, staticRenderFns } from "./InfoShow.vue?vue&type=template&id=73806642&"
import script from "./InfoShow.vue?vue&type=script&lang=js&"
export * from "./InfoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports